namespace advisorop.components.advisor {

    class CuRepCodeCustodianController {

        $router;
        public model: domains.IRepFeeGroupCustodian = {};
        custodians: Array<domains.ICustodian>;
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;
        selCustodian: domains.ICustodian;
        onCloseAreaForMapRepCode: any;
        public dg: DevExpress.ui.dxDataGridOptions;

        repGroupCustodians: Array<domains.IRepFeeGroupCustodian>;
        onMappedRepCode: any;

        static $inject = ["identityService", "generalService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService, private advisorService: services.AdvisorService) {
            this.model = {};

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "RelatedCustodiansForRepGroup"
                },
                bindingOptions: {
                    dataSource: "vm.relatedCustodiansForRepGroup"
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No mapped custodians for this rep group",
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'custodian.name', caption: 'Custodian Name', cellTemplate: 'colFullName', visible: true },
                    { dataField: 'custodianRepCode', caption: 'Rep Code', width: 180, visible: true },
                    { dataField: 'id', caption: 'Actions', cellTemplate: 'btnActions', width: 110 }

                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onAdvisorChanged({ id: data.id });
                //    }
                //}
            };


        }


        custodianChanged(): void {
            if (this.selCustodian) {
                this.model.custodianId = this.selCustodian.id;
            }
        }
    

        repGroupId: number;
        mapRepCode(): void {
            this.model.repFeeGroupId = this.loadRepGroupId;
            this.advisorService.mapCustodianRepCodeWithRepGroup(this.model)
                .then((response) => {

                    toastr.success("Code succesfully added.");
                    this.cleanEntries();
                    this.loadRelatedCustodiansForThisRepGroup(this.repGroupId);

                }).catch((response) => {
                    toastr.error(response.data);
                })
        }

        cleanEntries(): void {
            this.selCustodian = {};
            this.model = {};
        }

        updateRepCode(): void {
        }


        relatedCustodiansForRepGroup: Array<domains.IRepFeeGroupCustodian> = [];

        loadRelatedCustodiansForThisRepGroup(repGroupId: number): void {
            this.advisorService.getCustodiansForRepGroup(repGroupId)
                .then((response) => {
                    this.relatedCustodiansForRepGroup = response.data;

                    //console.log("CUSTODIANS FOR REP GROUP");
                    //console.log(this.relatedCustodiansForRepGroup);
                })
                .catch(error => {
                    toastr.error("Unable to fetch custodians for this rep group.");
                });
        }


        removeCustodianFromCustodianList(custodian: domains.IRepFeeGroupCustodian): void {
            
            var ind = this.relatedCustodiansForRepGroup.indexOf(custodian);
            if (ind >= 0)
                this.relatedCustodiansForRepGroup.splice(ind, 1);
            this.advisorService.removeCustodianMappedForRepGroup(custodian)
                .then(response => {
                    toastr.success("Custodian mapping succesfully removed from list.");
                })
                .catch(err => {
                    toastr.error("Unable to delete mapped custodian.");
                });
        };

   

        getCustodians(): void {
            this.advisorService.getCustodians()
                .success((data) => {
                    this.custodians = data;
                    //console.log("Custodians...");
                    //console.log(this.custodians);

                })
                .error((status, data) => {
                    toastr.error("GET CUSTODIANS ERROR " + status + " " + data);
                });
        };



        
        $onInit(): void {
            this.identityService.getUserPromise()
                .then(response => {
                    this.user = response;
                    this.currentAdvisor = response.advisor;
                });
            this.getCustodians();

        }


        $routerOnActivate(next, previous) {
        }

        loadRepGroupId: number;
        $onChanges(evt): void {

            for (var key in evt) {

                if (key === "repGroupId") {
                    if (this.repGroupId > 0 && this.repGroupId != this.loadRepGroupId) {
                        this.loadRepGroupId = this.repGroupId;
                        this.loadRelatedCustodiansForThisRepGroup(this.loadRepGroupId);
                    }
                }
            }

        }


    }


    class CuRepCodeCustodian implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
                repGroupCustodians: "<",
                repGroupId: "<",
                onCloseAreaForMapRepCode: "&",
                onMappedRepCode: "&"
            };
            this.controller = CuRepCodeCustodianController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/cu-rep-code-custodian.html';
        }
    }
    angular.module(Constants.APP).component("cuRepCodeCustodian", new CuRepCodeCustodian());


}